import { POPULAR_NEWBUILDING_PLACEHOLDER_IMAGE_URLS } from './constants';

function getSeedHash(seed: string) {
  return seed.split('').reduce((result, char) => result + char.charCodeAt(0), 0);
}

export function getPopularNewbuildingPlaceholderImageUrl(seed: number | string) {
  const placeholders = POPULAR_NEWBUILDING_PLACEHOLDER_IMAGE_URLS.filter(Boolean);

  if (!placeholders.length) {
    return undefined;
  }

  return placeholders[getSeedHash(String(seed)) % placeholders.length];
}
